export const REST_EXERCISE_ID = 276;



// WEBPACK FOOTER //
// ./src/data/constants.js